import { parseJwtPayload, tokenClaimsFromPayload } from '@/utils/jwtClaims';

export const parseJwt = (token: string) => parseJwtPayload(token);

export const tokenClaims = (token: string) => tokenClaimsFromPayload(parseJwtPayload(token));
